import React from 'react'

const Contact = () => {
    return (
        <div className='w-full bg-[#204058] py-10 '>
            <div className='flex flex-col gap-5  max-w-4xl p-5 mx-auto'>
                <div className='flex sm:flex-row flex-col items-center gap-5'>
                    <img src='https://sinoclear.net/pm/images-nw/contact-us.svg' className='w-12 h-12' />
                    <p className='text-white'>
                        If you are not happy with your purchase for any reason, contact us anytime, and we’ll refund every penny of your investment. You don’t even have to send the bottles back.
                    </p>
                </div>
                <a href="https://buygoods.com/thankyou?account_id=10398&amp;subid5=v2_10a8aace-0f8a-44a8-a764-4b0ebbd85e70_336c7c61-c4da-416a-9152-45384545a6b5_6765c427aed374ea40bacbb1_2237f13c-2dbf-4eaa-adf6-8b0180ada846_0_t-10" className='text-white underline'>
                    <p><strong class="">No Thanks</strong>, I understand that I will
                        never see this
                        offer again. I’d rather
                        pay full price later. Take me to the next
                        page.</p>
                </a>
            </div>
        </div>
    )
}
export default Contact
